import {ConfigurationService} from '~/app/core/common/services/configuration.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ApiService} from '~/app/core/common/services/api.service';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {OrderItemService} from '~/app/core/common/services/order-item.service';
import {ProfileService} from '~/app/core/common/services/profile.service';

export const SHARED_MODULES: any[] = [
    /** Add shared modules here */
];

export const COMPONENT_DECLARATIONS: any[] = [
    /** Add shared declarations here */
];

export const PROVIDERS: any[] = [
    ConfigurationService,
    StoreListService,
    ApiService,
    ResourceService,
    OrderItemService,
    ProfileService,
    /** Add shared providers here */
];
